import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import { fetchPluginKeys } from '@sportninja/common/services/account'
import type { PluginKey } from '@sportninja/common/features/account/apiAccess'

/** The account's active plugin keys. Waits for the account to load. */
export const usePluginKeys = (accountUid: string | undefined) =>
  useQuery<PluginKey[]>({
    queryKey: queryKeys.accountApiAccess.pluginKeys(accountUid),
    queryFn: () => fetchPluginKeys(accountUid as string),
    enabled: Boolean(accountUid),
  })
